import { makeStyles } from "@material-ui/core/styles"

let gray = "#9A9A9A"
let yellow = "#C9BE3B"
let green = "#41B25B"

const styles = makeStyles(theme => ({
  crewRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: "10px",
    marginTop: "10px",
  },
  crewNameWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    flexGrow: 1,
    maxWidth: "85%",
  },
  statusDotWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flexGrow: 1,
    maxWidth: "15%",
  },
  statusDot: {
    borderRadius: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  accepted: {
    // border: `1px solid ${theme.palette.success.main}`,
    border: `1px solid ${green}`,
    // backgroundColor: theme.palette.success.main,
    backgroundColor: `${green}`,
  },
  unassigned: {
    border: `1px solid ${gray}`,
    backgroundColor: gray,
  },
  unsent: {
    border: `1px solid ${gray}`,
  },
  sent: {
    border: `1px solid ${yellow}`,
  },
  rejected: {
    border: `1px solid red`,
  },
  available: {
    // border: `1px solid ${theme.palette.success.main}`,
    border: `1px solid ${green}`,
  },
  checkIcon: {
    color: "#FFF",
    width: "90%",
  },
}))

export default styles
